import {User} from '@hconnect/apiclient'
import {useSelector} from 'react-redux'

import {Permission} from '../modules/LoggedInUser'
import {
  selectLoggedInUserPermissions,
  selectLoggedInUserProfile
} from '../modules/LoggedInUser.selectors'

export const useLoggedInUserProfile = (loggedInUserProfile?: User | null) => {
  const selected = useSelector(selectLoggedInUserProfile)
  return loggedInUserProfile || selected
}

export const useLoggedInUserPermissions = (loggedInUserPermissions?: Permission[] | null) => {
  const selected = useSelector(selectLoggedInUserPermissions)
  return loggedInUserPermissions || selected
}
